import { useQuery } from "@tanstack/react-query";
import { getServices } from "../../api/apiServices";
import i18next from "i18next";

/**
 * Hook لجلب قائمة الخدمات المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 */
export function useGetServices(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["services", params, i18next.language],
        queryFn: () => getServices(params),
        retry: false,
    });

    const services = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, services, meta, refetch };
}